<template>
  <div class="msg-details site-wrapper">
    <div class="guide">
      <span>您的位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }"> 首页 </el-breadcrumb-item>
        <el-breadcrumb-item>开票信息管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="add">
      <el-button type="primary" size="mini" round @click="addHandle">新增</el-button>
    </div>
    <div class="info">
      <el-table v-loading="tableLoading" class="content_table" :data="tableData" style="width: 1168px;margin:  0 auto;">
        <el-table-column prop="deptName" label="企业名称"> </el-table-column>
        <el-table-column prop="ratepayCode" label="纳税人识别号"> </el-table-column>
        <el-table-column prop="bank" label="开户行"> </el-table-column>
        <el-table-column prop="bankAccount" label="开户行账号"> </el-table-column>
        <el-table-column prop="addr" label="企业地址"> </el-table-column>
        <el-table-column fixed="right" header-align="center" align="center" width="100" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editOne(scope.row)">编辑</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button type="text" style="color: #FF6F77;" @click="delOne(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mod-page">
        <pagination layout="prev, pager, next" v-show="totalPage > 0" :total="totalPage" :page.sync="pageIndex"
          :limit.sync="pageLimt" @pagination="getDataList" />
      </div>
    </div>
    <billingDetaile v-if="msgVisible" ref="billingDetaile" @fresh="getDataList"></billingDetaile>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import billingDetaile from "./billingDetaile.vue";
export default {
  components: {
    Pagination,
    billingDetaile
  },
  data() {
    return {
      tableLoading: false,
      msgVisible: false,
      tableData: [],
      totalPage: 0,
      pageIndex: 1,
      pageLimt: 10
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    addHandle() {
      this.msgVisible = true;
      this.$nextTick(() => {
        this.$refs.billingDetaile.init({});
      })
    },
    editOne(row) {
      this.msgVisible = true;
      this.$nextTick(() => {
        this.$refs.billingDetaile.init(JSON.parse(JSON.stringify(row)));
      })
    },
    delOne(id) {
      this.$confirm("确定删除开票信息？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: id
        };
        this.$http.post(this.$api.shiroApi.tickDel, params).then(({ data }) => {
          this.$message({
            message: data.msg,
            type: "success"
          });
          this.getDataList();
        });
      });
    },
    getDataList() {
      this.tableLoading = true;
      let params = {
        current: this.pageIndex,
        size: this.pageLimt,
        data: {}
      }
      this.$http.post(this.$api.shiroApi.tickList, params).then(({ data }) => {
        this.tableLoading = false;
        this.tableData = data.data.list;
        this.totalPage = data.data.total;
      }).catch(()=>{
				this.tableLoading = false;
			});
    }
  }
};
</script>

<style lang="scss" scoped>
.msg-details {
  position: relative;

  .guide {
    display: flex;
    margin-bottom: 0;
  }

  .info {
    min-height: 703px;
    padding-top: 16px;
    background: #fff;
    border-radius: 16px;
    margin-bottom: 56px;
  }

  .add {
    margin-bottom: 10px;
    text-align: right;

    button {
      padding: 8px 25px;
      font-size: 14px;
    }
  }

  .el-table .el-button {
    padding: 0;
  }
}
</style>
